import { TableContainer } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { ComponentProps, ElementType } from "react";

type CustomTableContainerProps = ComponentProps<typeof TableContainer> & {
  component?: ElementType;
};

const StyledTableContainer = styled(TableContainer)({
  width: "100%",
  maxWidth: "100%",
  minWidth: "100%",
  height: "100%",
  overflow: "auto",
  minHeight: 200,
  border: "none",
});

const CustomTableContainer = (props: CustomTableContainerProps) => {
  return <StyledTableContainer {...props} />;
};

export default CustomTableContainer;
